var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
		day:_vm.date.timestamp !== 0,
		empty:_vm.date.timestamp === 0,
		today:_vm.toDay === _vm.date.timestamp,
		from:_vm.from === _vm.date.timestamp,
		to:_vm.to === _vm.date.timestamp,
		// range:from < date.timestamp && to > date.timestamp,
		disabled:_vm.disabled,
	},on:{"click":_vm.selectedDay}},[_c('span',[_vm._v(_vm._s(_vm.date.day > 0 ? _vm.date.day : ''))])])}
var staticRenderFns = []

export { render, staticRenderFns }